import type { Key } from "react";
import type { SelectChangeEvent, SelectProps } from "@mui/material/Select";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import { usePaginatedRoles } from "@/src/lib/usePaginatedRoles/usePaginatedRoles";
import { InputLabel } from "@mui/material";

export interface RoleFilterProps extends Omit<
    SelectProps,
    "value" | "defaultValue" | "onChange"
> {
    value?: Key;
    defaultValue?: Key;
    onChange?: (event: { target: { value: Key } }) => void;
}

function RoleFilter(props: RoleFilterProps) {
    const { roles } = usePaginatedRoles(0, 999);
    const availableRoles = roles || [];

    const handleOnSelectChange = (event: SelectChangeEvent<Key>) => {
        props.onChange?.(event);
    };

    return (
        <FormControl fullWidth>
            <InputLabel id={"role-label"}>{props.label}</InputLabel>
            <Select
                labelId={"role-label"}
                data-testid="role-select"
                defaultValue={props.defaultValue}
                value={props.value}
                {...props}
                onChange={handleOnSelectChange}
            >
                {availableRoles.map((option) => (
                    <MenuItem value={option.id} key={option.id}>
                        {option.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default RoleFilter;
